import { iconsAndImages } from "../../assets/images";
import apartJson from "./apart.json";
import "./aprtStyle.scss";

export const Apart = () => {
    return (
        <section style={{ backgroundColor: "#305F520D" }} className="py-5">
            <div className="px-3">
                <h2
                    className="text-center bebas-neue-regular fw-normal mb-3"
                    data-aos="fade-right"
                >
                    {apartJson?.title}
                </h2>
                <p
                    className="text-center mx-auto apart-desc"
                    data-aos="fade-left"
                >
                    {apartJson?.content}
                </p>
                <div className="row w-100 m-auto g-4 pt-4 justify-content-center">
                    {apartJson?.apartDetails?.map((details, index) => (
                        <div
                            className="col-12 col-md-6 col-lg-4"
                            key={index}
                            data-aos="fade-up"
                            data-aos-delay={index * 120}
                        >
                            <div className="bg-white rounded-4 p-4 h-100 shadow-sm apart-card">
                                <div className="icon-box mb-3">
                                    <img
                                        src={iconsAndImages[details?.icon]}
                                        alt=""
                                        className="img-fluid"
                                        loading="lazy"
                                    />
                                </div>
                                <h5 className="bebas-neue-regular fw-normal py-2">
                                    {details?.title}
                                </h5>
                                <p className="mb-0 small">
                                    {details?.subDetails}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
